import { Settings } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import {
  CAPABILITY_TA_CONFIGURE_SITES,
  FEATURE_TIME_AND_ATTENDANCE,
} from "../../utils/UserAccessControlUtils";
import SitesAndRegionsPage from "./pages/SitesAndRegionsPage";
import SiteConfigurationPage from "./pages/SiteConfigurationPage";

/**
 * Routes for the Site Configuration feature module. Spread into the Time &
 * Attendance parent's `children` so the overview appears nested under the
 * Time & Attendance sidebar group.
 */
const SiteConfigurationRouter: NavigationLinkProps[] = [
  {
    id: "a1b2c3d4-e5f6-7890-abcd-site-configuration-overview",
    title: "Site Configuration",
    description: "Browse Regions, Sites, and Rosters",
    path: "/site-configuration",
    auth: true,
    sidebar: true,
    icon: Settings,
    component: SitesAndRegionsPage,
    requiredFeature: FEATURE_TIME_AND_ATTENDANCE,
    requiredPermissions: ["ANY"],
    requiredCapability: CAPABILITY_TA_CONFIGURE_SITES,
  },
  {
    id: "a1b2c3d4-e5f6-7890-abcd-site-configuration-detail",
    title: "Configure Site",
    description: "Per-Site configuration (defaults + Rosters)",
    path: "/site-configuration/:siteId",
    auth: true,
    sidebar: false,
    secondarySidebar: false,
    component: SiteConfigurationPage,
    requiredFeature: FEATURE_TIME_AND_ATTENDANCE,
    requiredPermissions: ["ANY"],
    requiredCapability: CAPABILITY_TA_CONFIGURE_SITES,
  },
];

export default SiteConfigurationRouter;
